<template>
  <div class="counter">
    <div class="counter__name">{{name}}</div>
    <div class="counter__progress">
      <div class="counter__progress__inner" v-bind:class="[color]" v-bind:style="{width: (percent*100)+'%'}"></div>
    </div>
    <div class="counter__progress counter__progress--vertical">
      <div class="counter__progress__inner" v-bind:class="[color]" v-bind:style="{height: (percent*100)+'%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Counter",
  data() {
    return{
    };
  },
  props: {
    name: String,
    color: String,
    percent: Number
  }
}
</script>

<style lang="scss">

#photovoltaics {
  .counter {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: $blue-dark;
    border-radius: 7px;
    color: $white;
    font-weight: 600;
    padding: 10px;
    margin-bottom: 6px;

    &__name{
      margin-bottom: 0.5rem;
      font-size: 12px;
    }

    &__progress{
      flex-grow: 1;
      position: relative;
      border-radius: 7px;
      background: $blue-light;
      min-height: 27px;
      overflow: hidden;

      &__inner{
        z-index: 4;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        transition: 1000ms;

        &.yellow{
          background-image: linear-gradient(to right, $yellow-gradient-left, $yellow-gradient-right);
        }
        &.red{
          background-image: linear-gradient(to right, $red-light, $red-gradient);
        }

      }

      &:after{
        z-index: 5;
        content: " ";
        position: absolute;
        display: block;
        top: 0;
        height: 8px;
        left: 0;
        right: 0;
        background: asset('progress.png') repeat-y top center;
        background-size: 100%;
      }

      &--vertical{
        //height: 100%;
        width: 30px;
        display: none;
        .counter__progress__inner{
          top: inherit;
          right: 0;
          &.yellow{
            background-image: linear-gradient(to top, $yellow-gradient-left, $yellow-gradient-right);
          }
          &.red{
            background-image: linear-gradient(to top, $red-light, $red-gradient);
          }
        }

        &:after{
          height: inherit;
          width: 8px;
          right: inherit;
          bottom: 0;
          background: asset('progress-v.png') repeat-x top center;
          background-size: 100% 100%;
        }

      }

    }
    @include media-breakpoint-up(xl) {
      width: auto;
      text-align: center;
      margin-left: 5px;
      margin-right: 4px;
      min-width: 70px;
      padding-left: 0;
      padding-right: 0;
      &__progress {
        display: none;

        &--vertical {
          margin-left: auto;
          margin-right: auto;
          display: block;
        }
      }
    }
  }
}
</style>
